class NotifyUserActionRequest {
  constructor (action, extra, televendasId) {
    this.acao = NotifyUserActionsEnum[action]
    this.extra = extra
    this.televendasId = televendasId
  }
}

const NotifyUserActionsEnum = {
  ACESSO: 'ACESSO',
  CONTRATAR: 'CONTRATAR',
  TROCA_SUCESSO: 'TROCA_SUCESSO',
  ADESAO: 'ADESAO'
}

export {
  NotifyUserActionRequest, NotifyUserActionsEnum
}
